import _ from 'underscore';

import {EventConstants, FluxAction} from 'constants/EventConstants';
import FileStates from 'FileStates';
import {FileSummary} from 'folder-items/FileConstants';
import syncItemNameToApolloCache from 'graphql-client/syncItemNameToApolloCache';
import AppDispatcher from 'lib/Dispatcher';
import Store from 'lib/Store';
import * as RegistryUtil from 'registry/RegistryUtil';

class FileBrowserStore extends Store {
  fileStates!: FileStates;
  recents!: Array<FileSummary> | null;

  // Only purpose of this is to set fileStates once everything is initialized (fileStates is needed in
  // multiple places, so better to set here than at every use)
  setFileStates(fileStates: FileStates): void {
    this.fileStates = fileStates;
  }

  override resetState(): void {
    this.recents = null;
  }

  getState(): {recents: Array<FileSummary> | null} {
    return {
      recents: this.recents,
    };
  }

  override payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.FILE_BROWSER_RECENTS_FETCHED:
        ({recents: this.recents} = action);
        this.emitChange();
        break;

      case EventConstants.FILE_BROWSER_RENAME_FILE: {
        const {id, name, displayLabel} = action;
        const model = this.fileStates.get(id)?.folderItemModelToSync();
        if (model != null) {
          // @ts-expect-error We don't alwyas pass `displyLabel` to this action, but `BaseFolderItem` expects a `string`
          model.setNameAndDisplayLabel(name, displayLabel);
        }
        // Keep the GraphQL cache in sync for every rename, regardless of who dispatched this
        // action (e.g. registry validation/registration, bulk bioentity edits, or the file
        // browser rename itself) and regardless of the item's specific GraphQL type.
        syncItemNameToApolloCache(id, name);
        break;
      }

      case EventConstants.FILE_BROWSER_MOVE_FILES_COMPLETED: {
        const {ids, folder} = action;
        // eslint-disable-next-line no-restricted-syntax
        _.each(ids, (id) => {
          const model = this.fileStates.get(id)?.folderItemModelToSync();
          if (model == null) {
            return;
          }
          if (RegistryUtil.isRegistry(folder!.source)) {
            model.syncProjectFolder(model.folder()!);
          }
          model.setFolder(folder!);
        });
        break;
      }

      case EventConstants.FILE_BROWSER_MOVE_SHORTCUTS_COMPLETED: {
        const {ids, folder} = action;
        // eslint-disable-next-line no-restricted-syntax
        _.each(ids, (id) => {
          const model = this.fileStates.get(id)?.folderItemModelToSync();
          if (model != null) {
            model.syncProjectFolder(folder!);
          }
        });
        break;
      }

      case EventConstants.FILE_BROWSER_UNREGISTER_FILES: {
        const {ids} = action;
        // eslint-disable-next-line no-restricted-syntax
        _.each(ids, (id) => {
          const model = this.fileStates.get(id)?.folderItemModelToSync();
          if (model != null) {
            model.clearProjectFolder();
          }
        });
        break;
      }

      default:
        break;
    }

    return true;
  }
}

export default new FileBrowserStore(AppDispatcher);
